(() => {
  const loader = document.currentScript;
  if (!loader) return;

  const desktop = window.matchMedia('(min-width: 750px)');
  const requested = new Map();

  const importOnce = (src) => {
    if (!src) return Promise.resolve();
    if (!requested.has(src)) requested.set(src, import(src));
    return requested.get(src);
  };

  const loadHeader = () =>
    Promise.all([importOnce(loader.dataset.overflowSrc), importOnce(loader.dataset.headerMenuSrc)]);

  const loadProducts = () =>
    Promise.all([
      importOnce(loader.dataset.productCardSrc),
      importOnce(loader.dataset.slideshowSrc),
      importOnce(loader.dataset.productPriceSrc),
    ]);

  const loadAccordions = () => importOnce(loader.dataset.accordionSrc);
  const loadLocalization = () => importOnce(loader.dataset.localizationSrc);

  const observeOnce = (selector, callback, rootMargin) => {
    const target = document.querySelector(selector);
    if (!target) return;

    if (!('IntersectionObserver' in window)) {
      callback();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        callback();
      },
      { rootMargin }
    );

    observer.observe(target);
  };

  const loadDesktopRuntime = () => {
    if (!desktop.matches) return;
    loadHeader();
    loadProducts();
    loadAccordions();
    loadLocalization();
  };

  loadDesktopRuntime();
  desktop.addEventListener?.('change', loadDesktopRuntime);

  if (desktop.matches) return;

  // Product cards sit below the homepage hero. Start their runtime shortly
  // before they enter the viewport instead of evaluating it during first paint.
  observeOnce('#MainContent product-card', loadProducts, '150px 0px');
  observeOnce('#MainContent accordion-custom', loadAccordions, '400px 0px');
  observeOnce(
    'localization-form-component, dropdown-localization-component, drawer-localization-component',
    loadLocalization,
    '300px 0px'
  );

  const loadForIntent = (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('product-card')) loadProducts();
    if (target.closest('.header__icon--menu, accordion-custom')) loadAccordions();
    if (
      target.closest(
        'localization-form-component, dropdown-localization-component, drawer-localization-component'
      )
    ) {
      loadLocalization();
    }
  };

  document.addEventListener('pointerdown', loadForIntent, { capture: true, passive: true });
  document.addEventListener('focusin', loadForIntent, { capture: true });
})();
